// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"934965f0","260":"25fe3378","334":"337ac074","355":"260d61b7","453":"15a626a8","537":"f41c9392","801":"1f035278","856":"4a748d9a","919":"00294fd1"}[chunkId] + ".chunk.js";
};